import { setPreference } from '@fs/zion-preferences'

export default function updateObjectPreference<T>(
  defaultValue: T | undefined,
  preferenceValue: T | '' | undefined,
  preferenceKey: string
): void {
  // If defaultValue and preferenceValue are of type Record<string, unknown>, then look through the first layer and update the preference if there are any missing fields.
  if (
    defaultValue &&
    defaultValue instanceof Object &&
    !(defaultValue instanceof Array) &&
    preferenceValue &&
    preferenceValue instanceof Object &&
    !(preferenceValue instanceof Array)
  ) {
    let updateValue = false
    const updatedDefaultValue = Object.keys(defaultValue).reduce((accum, defaultKey) => {
      if (preferenceValue[defaultKey] !== undefined) {
        accum[defaultKey] = preferenceValue[defaultKey]
      } else {
        // At least one field is missing and we need to update the whole preference to include this new value via updatedDefaultValue
        updateValue = true
      }
      return accum
    }, defaultValue)

    updateValue && setPreference(preferenceKey, updatedDefaultValue)
  }
}
